"use client";
// Client-side Algolia utilities
import algoliaInsights from "search-insights";
import { InsightsMethodMap } from "search-insights";
import { getAlgoliaGuestUserTokenClient } from "../commonClientUtils";
import { getAlgoliaAuthenticatedUserToken } from "../commonUtils";
import { algoliaEventParam } from "./constants";

export const algoliaClickEventClient = async (
  event: keyof InsightsMethodMap,
  index: string,
  eventName: string,
  objectID: string,
  queryID: string,
  positions: number,
  magrabiId?: string,
) => {
  const userToken = await getAlgoliaGuestUserTokenClient();
  algoliaInsights(event, {
    index,
    eventName,
    queryID,
    objectIDs: [objectID],
    positions: [positions],
    userToken: userToken ?? undefined,
    authenticatedUserToken: getAlgoliaAuthenticatedUserToken(magrabiId),
  });
};

export const algoliaClickedObjectIDSClient = async (
  event: keyof InsightsMethodMap,
  index: string,
  eventName: string,
  objectID: string,
  magrabiId?: string,
) => {
  const userToken = await getAlgoliaGuestUserTokenClient();
  algoliaInsights(event, {
    index,
    eventName,
    objectIDs: [objectID],
    userToken: userToken ?? undefined,
    authenticatedUserToken: getAlgoliaAuthenticatedUserToken(magrabiId),
  });
};

export const algoliaViewedEventClient = async (
  event: keyof InsightsMethodMap,
  index: string,
  eventName: string,
  objectID: string,
  magrabiId?: string,
) => {
  const userToken = await getAlgoliaGuestUserTokenClient();
  algoliaInsights(event, {
    index,
    eventName,
    objectIDs: [objectID],
    userToken: userToken ?? undefined,
    authenticatedUserToken: getAlgoliaAuthenticatedUserToken(magrabiId),
  });
};

export const algoliaConversionEventClient = async (
  event: keyof InsightsMethodMap,
  index: string,
  eventName: string,
  objectID: string,
  queryID: string,
  magrabiId?: string,
) => {
  const userToken = await getAlgoliaGuestUserTokenClient();
  algoliaInsights(event, {
    index,
    eventName,
    queryID,
    objectIDs: [objectID],
    userToken: userToken ?? undefined,
    authenticatedUserToken: getAlgoliaAuthenticatedUserToken(magrabiId),
  });
};

export const algoliaViewedObjectIDsListClient = async (
  index: string,
  eventName: string,
  objectIDs: string[],
  magrabiId?: string,
) => {
  const userToken = await getAlgoliaGuestUserTokenClient();
  algoliaInsights(algoliaEventParam.PRODUCT_VIEW, {
    index,
    eventName,
    objectIDs: objectIDs,
    userToken: userToken ?? undefined,
    authenticatedUserToken: getAlgoliaAuthenticatedUserToken(magrabiId),
  });
};

export const algoliaAddToCartWithQueryClient = async (
  index: string,
  eventName: string,
  variantId: string,
  queryID?: string,
  magrabiId?: string,
) => {
  const userToken = await getAlgoliaGuestUserTokenClient();
  const method: keyof InsightsMethodMap = queryID
    ? "addedToCartObjectIDsAfterSearch"
    : "addedToCartObjectIDs";
  algoliaInsights(method, {
    index,
    eventName,
    objectIDs: [variantId],
    ...(queryID ? { queryID } : {}),
    userToken: userToken ?? undefined,
    authenticatedUserToken: getAlgoliaAuthenticatedUserToken(magrabiId),
  });
};

export const algoliaWishlistConversionClient = async (
  index: string,
  eventName: string,
  variantId: string,
  queryID?: string,
  magrabiId?: string,
) => {
  const userToken = await getAlgoliaGuestUserTokenClient();
  const method: keyof InsightsMethodMap = queryID
    ? "convertedObjectIDsAfterSearch"
    : "convertedObjectIDs";
  algoliaInsights(method, {
    index,
    eventName,
    objectIDs: [variantId],
    ...(queryID ? { queryID } : {}),
    userToken: userToken ?? undefined,
    authenticatedUserToken: getAlgoliaAuthenticatedUserToken(magrabiId),
  });
};

/**
 * Fires filters events (clickedFilters, viewedFilters, convertedFilters).
 */
export const algoliaFilterEventClient = async (
  event: keyof InsightsMethodMap,
  index: string,
  eventName: string,
  filters: string[],
  magrabiId?: string,
) => {
  if (!filters.length) return;
  algoliaInsights(event, {
    index,
    eventName,
    filters,
    userToken: (await getAlgoliaGuestUserTokenClient()) ?? undefined,
    authenticatedUserToken: getAlgoliaAuthenticatedUserToken(magrabiId),
  });
};

/**
 * Fires purchasedObjectIDsAfterSearch event.
 */
export const algoliaPurchaseEventClient = async (
  index: string,
  eventName: string,
  objectIDs: string[],
  objectData: { queryID?: string; price: number; quantity: number }[],
  totalValue: number,
  currency: string,
  magrabiId?: string,
) => {
  const userToken = await getAlgoliaGuestUserTokenClient();
  algoliaInsights(algoliaEventParam.PURCHASED_AFTER_SEARCH, {
    index,
    eventName,
    objectIDs,
    objectData,
    value: totalValue,
    currency,
    userToken: userToken ?? undefined,
    authenticatedUserToken: getAlgoliaAuthenticatedUserToken(magrabiId),
  });
};
